export default "/images/38f62fbe1dba47c3fad4a2cc858e234b.avif";